import { render } from "./TopicAiCrateView.vue?vue&type=template&id=b5268010"
import script from "./TopicAiCrateView.vue?vue&type=script&lang=js"
export * from "./TopicAiCrateView.vue?vue&type=script&lang=js"

import "./TopicAiCrateView.vue?vue&type=style&index=0&id=b5268010&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__